import { generateUtilityClass, generateUtilityClasses } from '../className';
export function getIconButtonUtilityClass(slot) {
  return generateUtilityClass('JoyIconButton', slot);
}
const iconButtonClasses = generateUtilityClasses('JoyIconButton', ['root', 'colorPrimary', 'colorNeutral', 'colorDanger', 'colorInfo', 'colorSuccess', 'colorWarning', 'variantPlain', 'variantOutlined', 'variantSoft', 'variantSolid', 'focusVisible', 'disabled', 'sizeSm', 'sizeMd', 'sizeLg']);
export default iconButtonClasses;